import trimText from "@/functions/trimText";
import useJob from "@/hooks/useJob";
import { JobPostingSchema } from "@/ui/JobPostingSchema";
import { SeoHead } from "@/ui/SeoHead";
import getPaths from "@sourceflow-uk/functions/getPaths";
import { ContentBlocks } from "src/ui/ContentBlocks";
import * as additionalComponents from "./__components";

export default function JobPostPage({ prefix, metadata, url_slug, data }) {
  return (
    <>
      <SeoHead {...metadata} />
      <JobPostingSchema url_slug={url_slug} />
      <ContentBlocks data={data} prefix={prefix} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const {
    id,
    featured,
    description,
    title,
    location,
    salary_package,
    working_options,
    updated_at,
    external_reference,
    employment_types,
    consultant,
    skills,
    sectors,
  } = useJob(url_slug);

  return {
    props: {
      prefix: `jobs_${url_slug}`,
      metadata: {
        title,
        description: trimText(description.replaceAll("ROLE OVERVIEW", ""), 158),
        canonical: `/jobs/${url_slug}/`,
      },
      url_slug,
      data: [
        {
          component: "JobPostHero",
          props: {
            featured,
            title,
            location,
            salary_package,
            external_reference,
            employment_types,
            updated_at,
            working_options,
          },
        },
        {
          component: "JobPostContent",
          props: {
            id,
            description,
            consultant,
            skills,
            sectors,
          },
        },
        {
          component: "JobsCarousel",
          props: {
            className: "text-center pb-5 pb-md-6",
            title: "Other Similar Jobs",
            description: "<p>Your next opportunity is just a click away!</p>",
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: await getPaths("jobs", "url_slug", "jobs"),
    fallback: false,
  };
}
